import React, {
  createContext,
  useContext,
  useState,
  useMemo,
} from "react";
import { useNavigate } from "react-router-dom";

const AuthContext = createContext();
export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(
    () => JSON.parse(localStorage.getItem("user")) || null
  );
  const [authenticated, setAuthenticated] = useState(
    () => !!localStorage.getItem("user")
  );
  const navigate = useNavigate();

  const login = (userData) => {
    setAuthenticated(true);
    setUser(userData);
    localStorage.setItem("user", JSON.stringify(userData));
  };

  const logout = () => {
    setAuthenticated(false);
    setUser(null);
    navigate("/");
    localStorage.removeItem("user");
  };

  const checkAuth = async ({ skipLogoutOnFail = false } = {}) => {
    try {
      const response = await fetch("/api/portal/pms/isUserAuthenticated", {
        credentials: "include",
      });
      const data = await response.json();
      if (response.ok) {
        if (data.name) {
          setAuthenticated(true);
          setUser(data);
          localStorage.setItem("user", JSON.stringify(data));
          return true;
        } else {
          if (!skipLogoutOnFail) {
            logout();
          }
          return false;
        }
      } else {
        console.error("Unauthorized or other error", response.status);
        if (!skipLogoutOnFail) {
          logout();
        }
        return false;
      }
    } catch (error) {
      console.error("Auth check failed:", error);
      if (!skipLogoutOnFail) {
        logout();
      }
      return false;
    }
  };
  const userName = user?.name;
  const userRole = user?.role;

  const value = useMemo(
    () => ({ authenticated, userName, userRole, login, logout, checkAuth }),
    [authenticated, userName]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
